// Direct process.env checks so webpack drops the unused client at build time
export const clientKey =
  process.env.VUE_APP_CLIENT === "petruth" ? "petruth" : "queenwood";

export const authToken =
  process.env.VUE_APP_CLIENT === "petruth"
    ? "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXlsb2FkIjp7InNjb3BlIjoicmVhZCIsImNsaWVudElkIjoxNzh9LCJpYXQiOjE2MTc4MDgyNjB9.CdcowZEM4NQbJc1bifzkeeoflS4Tzq7-lSYAqpPICPU"
    : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXlsb2FkIjp7InNjb3BlIjoicmVhZCIsImNsaWVudElkIjo4OTJ9LCJpYXQiOjE2NjA5ODg3OTh9.j3nieCiFWWrjMB4HineUUc8ZSUhaUjaHG6NkV2F5vJs";
